// extracted by mini-css-extract-plugin
export default {"example":"AssessmentExample_example__0x3CE"};